(() => {
  const youtubeId = (value = '') => value.match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/))([\w-]{6,})/i)?.[1];
  const cleanHost = (node) => {
    const host = node?.closest('figure, p');
    if (host && !host.textContent.trim() && !host.querySelector('img, iframe, video')) host.remove();
  };
  const storyDate = (value = '') => {
    const match = value.match(/(?:January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec)\s+\d{1,2},?\s+\d{4}/i);
    if (!match) return null;
    const date = new Date(Date.parse(match[0].replace(/(\d{1,2})\s+(\d{4})$/, '$1, $2')));
    return Number.isNaN(date.getTime()) ? null : date;
  };
  const formatStoryDate = (date, short = false) => new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
    year: 'numeric', month: short ? 'short' : 'long', day: 'numeric', timeZone: 'UTC'
  }).format(date);
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const isNtcriStory = /\/blogs\/stories\/aoi-cycle-x-national-taiwan-craft-research-and-development-institute-the-journey-to-carpentry/i.test(window.location.pathname);
    const isKenHsiehImage = (image) => /ken hsieh|damanwoo-designboom-04/i.test(`${image.alt || ''} ${image.currentSrc || ''} ${image.src || ''}`);
    if (isNtcriStory) {
      root.querySelectorAll('img').forEach((image) => {
        if (isKenHsiehImage(image)) image.style.objectPosition = 'center 55%';
      });
    }
    const inlineMediaStoryPath = '/blogs/stories/aoi-cycle-x-national-taiwan-craft-research-and-development-institute-the-journey-to-carpentry';
    if (window.location.pathname.replace(/\/$/, '') === inlineMediaStoryPath) {
      root.classList.add('aoi-story--inline-media');
    }
    const contentRoots = [...root.querySelectorAll('[data-story-content] rte-formatter')];
    const content = root.querySelector('[data-story-content="legacy"] rte-formatter') || contentRoots[0];
    if (!content) return;

    const leadingBlocks = [...content.children].slice(0, 4);
    const datePattern = /^(?:(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+\d{1,2},?\s+\d{4}|\d{1,2}[.\/-]\d{1,2}[.\/-]\d{2,4})/i;
    const sourceDate = leadingBlocks.find((node) => datePattern.test(node.textContent.trim()));
    if (sourceDate) {
      const dateTarget = root.querySelector('[data-story-date]');
      const matchedDate = sourceDate.textContent.trim().match(datePattern)?.[0] || '';
      const parsedDate = storyDate(matchedDate);
      dateTarget.textContent = matchedDate.toUpperCase();
      if (parsedDate) dateTarget.dateTime = parsedDate.toISOString().slice(0, 10);
      if (sourceDate.textContent.trim() === matchedDate) sourceDate.remove();
      else {
        const walker = document.createTreeWalker(sourceDate, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          if (datePattern.test(walker.currentNode.nodeValue.trimStart())) {
            walker.currentNode.nodeValue = walker.currentNode.nodeValue.trimStart().replace(datePattern, '').trimStart();
            break;
          }
        }
      }
    }
    const sourceCredit = leadingBlocks.find((node) => /^(?:photos?|photography)\s+(?:by|:)\s+/i.test(node.textContent.trim()));
    if (sourceCredit) { const credit = root.querySelector('[data-story-credit]'); credit.textContent = sourceCredit.textContent.trim().toUpperCase(); credit.hidden = false; sourceCredit.remove(); }
    const pageTitle = root.querySelector('.aoi-story__hero h1')?.textContent.trim().toLowerCase();
    [...content.children].slice(0, 3).forEach((node) => {
      if (/^H[12]$/.test(node.tagName) && node.textContent.trim().toLowerCase() === pageTitle) node.remove();
    });

    const quoteRegion = root.querySelector('[data-story-quote]');
    const quote = content.querySelector('blockquote');
    const regionQuote = quoteRegion?.querySelector('blockquote');
    if (quoteRegion && quote) {
      if (regionQuote?.querySelector('[data-auto-quote]')) regionQuote.replaceWith(quote);
      else if (!regionQuote) quoteRegion.append(quote);
    }
    const displayedQuote = quoteRegion?.querySelector('blockquote');
    if (displayedQuote && !displayedQuote.querySelector(':scope > span')) {
      const span = document.createElement('span');
      while (displayedQuote.firstChild) span.append(displayedQuote.firstChild);
      displayedQuote.append(span);
    }
    const quoteSpan = displayedQuote?.querySelector(':scope > span');
    if (quoteSpan && !quoteSpan.children.length) {
      quoteSpan.textContent = quoteSpan.textContent.trim().replace(/\s+(\S+)$/, '\u00a0$1');
    }
    const autoQuote = quoteRegion?.querySelector('[data-auto-quote]');
    if (autoQuote) {
      const sentences = [...content.querySelectorAll('p')]
        .flatMap((node) => node.textContent.trim().match(/[^.!?。！？]+[.!?。！？]+/g) || [])
        .map((text) => text.trim())
        .filter((text) => text.length >= 55 && text.length <= 190 && !/^(?:photos?|original article|image|video)/i.test(text));
      const score = (text) => {
        let value = 190 - Math.abs(112 - text.length);
        if (/[‘’“”"']/.test(text)) value += 60;
        if (/craft|design|create|build|purpose|lasting|material|meaning|life|dream/i.test(text)) value += 30;
        return value;
      };
      const selected = sentences.sort((a, b) => score(b) - score(a))[0];
      if (selected) autoQuote.textContent = selected;
    }

    const firstContentBlock = content.firstElementChild;
    const firstVideoSource = firstContentBlock?.querySelector('a')?.href || firstContentBlock?.textContent.trim() || '';
    const inlineVideo = firstContentBlock?.matches('.aoi-story-inline-video') || (firstContentBlock?.tagName === 'P' && youtubeId(firstVideoSource))
      ? firstContentBlock
      : null;
    if (inlineVideo) {
      const source = inlineVideo.querySelector('a')?.href || inlineVideo.textContent.trim();
      const id = youtubeId(source);
      if (id) {
        const player = document.createElement('div');
        player.className = 'aoi-story__inline-video-player';
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0`;
        iframe.title = root.querySelector('h1')?.textContent || 'AOI.CYCLE story video';
        iframe.loading = 'eager';
        iframe.allowFullscreen = true;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        player.append(iframe);
        inlineVideo.replaceWith(player);
      }
    }

    const introParagraphs = [];
    let introLength = 0;
    const articleWordCount = content.textContent.trim().split(/\s+/).filter(Boolean).length;
    for (const node of [...content.children]) {
      if (node.tagName !== 'P' || node.querySelector('img, iframe, video') || !node.textContent.trim()) break;
      const length = node.textContent.trim().length;
      if (length > 520 || introLength + length > 980 || introParagraphs.length === 3) break;
      introParagraphs.push(node); introLength += length;
    }
    if (articleWordCount >= 240 && introParagraphs.length >= 2) {
      const intro = document.createElement('div');
      intro.className = 'aoi-story__intro';
      introParagraphs[0].before(intro);
      introParagraphs.forEach((paragraph) => intro.append(paragraph));
    }

    const gallery = root.querySelector('[data-story-gallery]');
    if (gallery) {
      const heroImage = root.querySelector('.aoi-story__hero-media img');
      const contentImages = contentRoots.flatMap((contentRoot) => [...contentRoot.querySelectorAll('img')]).filter((image) => !image.closest('iframe, video'));
      const uploadedImages = [...root.querySelectorAll('[data-story-gallery-source] img')];
      const galleryImages = uploadedImages.length ? uploadedImages : contentImages;
      const images = heroImage ? [heroImage, ...galleryImages] : galleryImages;
      const feature = gallery.querySelector('[data-gallery-feature]');
      const thumbs = gallery.querySelector('[data-gallery-thumbs]');
      const counter = gallery.querySelector('[data-gallery-count]');
      const progress = gallery.querySelector('[data-gallery-progress]');
      const mobileGallery = window.matchMedia('(max-width: 767px)');
      let index = 0;
      const sources = images.map((image) => ({
        src: image.currentSrc || image.src,
        srcset: image.srcset,
        sizes: image.sizes,
        alt: image.alt || root.querySelector('h1')?.textContent || 'AOI.CYCLE story photo'
      }));
      if (!root.classList.contains('aoi-story--inline-media')) {
        galleryImages.forEach((image) => { const host = image.closest('figure, p'); image.remove(); cleanHost(host); });
      }
      const paint = () => {
        feature.replaceChildren();
        const visibleCount = mobileGallery.matches ? 1 : Math.min(3, sources.length);
        Array.from({ length: visibleCount }, (_, offset) => offset).forEach((offset) => {
          const item = sources[(index + offset) % sources.length];
          const figure = document.createElement('figure');
          const image = new Image();
          Object.assign(image, { src: item.src, alt: item.alt, loading: offset ? 'lazy' : 'eager' });
          if (isNtcriStory && isKenHsiehImage(image)) image.style.objectPosition = 'center 55%';
          if (item.srcset) image.srcset = item.srcset;
          if (item.sizes) image.sizes = item.sizes;
          figure.append(image); feature.append(figure);
        });
        [...thumbs.children].forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
        counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(sources.length).padStart(2, '0')}`;
        progress.style.width = `${((index + 1) / sources.length) * 100}%`;
      };
      sources.forEach((item, i) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'aoi-story__thumb';
        button.setAttribute('aria-label', `Show photo ${i + 1} of ${sources.length}`);
        const image = new Image(); image.src = item.src; image.alt = ''; image.loading = 'lazy'; button.append(image);
        button.addEventListener('click', () => { index = i; paint(); button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
        thumbs.append(button);
      });
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => { index = (index - 1 + sources.length) % sources.length; paint(); });
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => { index = (index + 1) % sources.length; paint(); });
      mobileGallery.addEventListener('change', paint);
      paint();
    }

    const videoRegion = root.querySelector('[data-story-video]');
    if (videoRegion) {
      const player = videoRegion.querySelector('[data-video-player]');
      const caption = videoRegion.querySelector('[data-video-caption]');
      const embedded = contentRoots.flatMap((contentRoot) => [...contentRoot.querySelectorAll('iframe, video')])[0];
      let source = videoRegion.dataset.videoSource || embedded?.src || embedded?.querySelector('source')?.src || '';
      if (!source) {
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        let textNode;
        while (walker.nextNode()) {
          if (youtubeId(walker.currentNode.nodeValue || '')) { textNode = walker.currentNode; break; }
        }
        source = textNode?.nodeValue.match(/https?:\/\/[^\s<]+/i)?.[0] || '';
        if (textNode && source) textNode.nodeValue = textNode.nodeValue.replace(source, '').trim();
      }
      if (embedded) {
        const host = embedded.closest('figure, p');
        if (embedded.tagName === 'IFRAME' && youtubeId(embedded.src)) embedded.src = `https://www.youtube-nocookie.com/embed/${youtubeId(embedded.src)}?autoplay=1&mute=1&playsinline=1&rel=0`;
        if (embedded.tagName === 'VIDEO') { embedded.autoplay = true; embedded.muted = true; embedded.playsInline = true; }
        player.append(embedded); cleanHost(host);
      }
      else if (youtubeId(source)) {
        const iframe = document.createElement('iframe'); iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId(source)}?autoplay=1&mute=1&playsinline=1&rel=0`;
        iframe.title = root.querySelector('h1')?.textContent || 'AOI.CYCLE story video'; iframe.loading = 'lazy'; iframe.allowFullscreen = true;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'; player.append(iframe);
      } else if (source) {
        const link = document.createElement('a'); link.href = source; link.textContent = 'WATCH VIDEO'; player.append(link);
      }
    }

    root.querySelectorAll('a[href]').forEach((link) => {
      link.target = '_blank';
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', [...rel].join(' '));
    });

  };
  const boot = (scope = document) => scope.querySelectorAll('[data-aoi-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
